import MessageList from './MessageList';
import './style/index.less';

export default MessageList;
